module.exports = __webpack_public_path__ + "static/media/edit.8981cd9e.svg";